<!-- MultiTab Header  -->
<ul
	*ngIf="tabItemsDataList?.length > 1"
	class="tab-nav--wrapper justify-content-center {{ tabNavWrapperClass ? tabNavWrapperClass : '' }}"
>
	<!-- Tab Item -->
	<li
		*ngFor="let tabItem of tabItemsDataList"
		class="tab-nav--item my-2 fs-sx {{tabItem.tabItemStyleClass}} "
		[ngClass]="{
			'fw-regular': activeTab !== tabItem?.tabIdentifier,
			'active fw-medium': activeTab === tabItem?.tabIdentifier,
			'disabled': tabItem?.disabled
		}"
		(click)="activeTab = tabItem?.tabIdentifier; tabSwitched.emit(tabItem?.tabIdentifier)"
	>

		<!-- Default -->
		<ng-container
			*ngIf="!tabItem.template?.navRef"
			[ngTemplateOutlet]="defaultNavRefTpl"
			[ngTemplateOutletContext]="{ 'tabItem': tabItem }"
		></ng-container>

		<!-- Custom Nav Ref -->
		<ng-container
			*ngIf="tabItem.template?.navRef"
			[ngTemplateOutlet]="customNavRefTpl"
			[ngTemplateOutletContext]="{ 'tabItem': tabItem }"
		></ng-container>
	</li>
</ul>

<!-- SingleTab Header -->
<h2
	*ngIf="tabItemsDataList && tabItemsDataList?.length === 1"
	class="headline-separator"
>
	{{ getI18nString( false, singleTabI18nTitlePath ) | uppercase }}
</h2>

<!-- Tab Contents -->
<div
	*ngIf="renderTabContents"
	class="tab-content--wrapper {{ tabContentWrapperClass ? tabContentWrapperClass : '' }}"
>

	<!-- Tab Item -->
	<ng-container *ngFor="let tabItem of tabItemsDataList">
		<div
			class="tab-content--pane {{ tabItem?.tabContentPanelClass ? tabItem?.tabContentPanelClass : '' }}"
			[ngClass]="{'active': activeTab === tabItem.tabIdentifier }"
			[ngStyle]="{transform: 'translateX(-' + (100 * (getIndexOfActiveTab()))  +'%)'}"
		>
			<ng-container *ngIf="activeTab === tabItem.tabIdentifier">
				<ng-container
					*ngTemplateOutlet="tabItem.template?.contentRef; context: { context: tabItem.template?.contentContext }"
				></ng-container>
			</ng-container>
		</div>
	</ng-container>
</div>

<ng-template #customNavRefTpl let-tabItem="tabItem">

	<!-- Prepended -->
	<ng-container
		*ngIf="!!tabItem.template?.navRef?.navRefPrependedContent"
		[ngTemplateOutlet]="tabItem.template?.navRef.navRefPrependedContent"
		[ngTemplateOutletContext]="{ 'context': tabItem.template?.navRef.navContext }"
	></ng-container>

	<!-- Label -->
	<ng-container
		[ngTemplateOutlet]="defaultNavRefTpl"
		[ngTemplateOutletContext]="{ 'tabItem': tabItem }"
	></ng-container>

	<!-- Appended -->
	<ng-container
		*ngIf="!!tabItem.template?.navRef?.navRefAppendedContent"
		[ngTemplateOutlet]="tabItem.template?.navRef.navRefAppendedContent"
		[ngTemplateOutletContext]="{ 'context': tabItem.template?.navRef.navContext }"
	></ng-container>
</ng-template>

<ng-template #defaultNavRefTpl let-tabItem="tabItem">
	<span
		[ngClass]="{
			'ms-1': !!tabItem.template?.navRef?.navRefPrependedContent,
			'me-1': !!tabItem.template?.navRef?.navRefAppendedContent
		}"
	>
		{{ getI18nString( false, tabItem?.i18nTitlePath ) }}
	</span>
</ng-template>
